// MPK - Marketing Partner Key
export const MPK_LENTA_B2C_DELIVERY = 'mp80-661295c9cbf9d6b2f6428414504a8deed3020641';
export const MPK_LENTA_B2C_PICKUP = 'mp300-b1de0bac2c257f3257bf5ef2eea4ecbc';
export const MPK_LENTA_B2B_DELIVERY = 'mp200-e86823887bcb4bf397df8c224f1a9dbf';
export const MPK_LENTA_B2B_PICKUP = 'mp290-be269503c7334818b474f565fc266555';
export const MPK_UTKONOS_DELIVERY = 'mp80-661295c9cbf9d6b2f6428414504a8deed3020641';
export const MPK_DOM_B2C_DELIVERY = 'mp601-98351ad07dd12d9c707ea638f06f40a8';
export const MPK_DOM_B2C_PICKUP = 'mp602-df5de1e24d9b660268119812726e8d2c';
export const MPK_MONETKA_B2C_DELIVERY = 'mp503-41826e1722dsu3yt07763fbcdb2f4c9b';
export const MPK_SUPERJAM_B2C_DELIVERY = 'mp735-2ab1365adfba6b864cb0ba8128607313';
export const MPK_SUPERJAM_B2C_PICKUP = 'mp736-942295e7f0366ca5be7f623e813b71dc';
export const MPK_REMI_B2C_DELIVERY = 'mp713-8a3d6f1c9e4b2a7d5f0c8e3b6a1d9f4c';
export const MPK_REMI_B2C_PICKUP = 'mp714-4e7b2a5d8f1c3e6a9d0b4f7c2e5a8d1b';

export enum MPKeys {
  LENTA_B2B_DELIVERY = MPK_LENTA_B2B_DELIVERY,
  LENTA_B2C_DELIVERY = MPK_LENTA_B2C_DELIVERY,
  LENTA_B2B_PICKUP = MPK_LENTA_B2B_PICKUP,
  LENTA_B2C_PICKUP = MPK_LENTA_B2C_PICKUP,
  DOM_B2C_DELIVERY = MPK_DOM_B2C_DELIVERY,
  DOM_B2C_PICKUP = MPK_DOM_B2C_PICKUP,
  UTKONOS_DELIVERY = MPK_UTKONOS_DELIVERY,
  MONETKA_B2C_DELIVERY = MPK_MONETKA_B2C_DELIVERY,
  SUPERJAM_B2C_DELIVERY = MPK_SUPERJAM_B2C_DELIVERY,
  SUPERJAM_B2C_PICKUP = MPK_SUPERJAM_B2C_PICKUP,
  REMI_B2C_DELIVERY = MPK_REMI_B2C_DELIVERY,
  REMI_B2C_PICKUP = MPK_REMI_B2C_PICKUP,
}

export const AppCacheMPKKey = 'App_Cache_MPK';
